var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from "../../../pages/modules/base-entity";
import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { Router } from "aurelia-router";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { RouterConstants } from "../../../../configuration/router.constants";
import { I18N } from "aurelia-i18n";
import { StepEnum } from "../../../../models/modules/lotteryplatofrm.models";
import { TicketLineClientService } from "../../../../services/modules/ticket-line.service";
import { TransactionOverview } from "./steps/transaction-overview";
var TicketLines = /** @class */ (function (_super) {
    __extends(TicketLines, _super);
    function TicketLines(dialogClientService, router, bindingEngine, notificationService, eventAggregator, i18N, ticketLineClientService, transactionOverview) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.ticketLineClientService = ticketLineClientService;
        _this.transactionOverview = transactionOverview;
        _this.activityLogEntitiesSave = [EntityTypes.Player];
        return _this;
    }
    TicketLines.prototype.activate = function (params, navigationInstruction) {
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    TicketLines.prototype.attached = function () {
        return _super.prototype.attached.call(this);
    };
    TicketLines.prototype.getSteps = function () {
        return [
            {
                title: this.i18N.tr("transaction-overview"),
                step: StepEnum.TransactionOverview,
                vm: this.transactionOverview,
                show: true,
                view: "../../app/admin/ticket-lines/steps/transaction-overview.html"
            },
        ];
    };
    // Inherited
    TicketLines.prototype.getItem = function (id) {
        var request = { id: id };
        return this.ticketLineClientService.getTicketLine(request);
    };
    TicketLines.prototype.getItemId = function () {
        return this.item.gamePlayerTicketLineId;
    };
    TicketLines.prototype.getEntityType = function () {
        return null;
    };
    TicketLines.prototype.beforeSave = function (skipValidation, resolve) {
        return null;
    };
    TicketLines.prototype.saveItem = function (id, changes) {
        return null;
    };
    TicketLines.prototype.getUpdateRoute = function () {
        return null;
    };
    TicketLines.prototype.initializeItemForCreate = function () {
        return null;
    };
    TicketLines.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListTicketLines;
    };
    TicketLines = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService,
            Router, BindingEngine, NotificationClientService,
            EventAggregator, I18N, TicketLineClientService,
            TransactionOverview])
    ], TicketLines);
    return TicketLines;
}(BaseEntity));
export { TicketLines };
